// import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { useParams } from 'react-router-dom'
import React, { useState, useEffect } from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'
import useStyle from './useStyles'
import ProductsTable from './TableNavigable/TableNavigable'
import { getSubscriberSuscriptionCommProduct } from '../../../app/services/CustomerAndProducts/getSubscriberSuscriptionCommProduct'

import {
  SnackBarError,
  SnackBarSuccess
} from '../../../components/SnackBars/SnackBars'
import BreadcrumbsComponent from './Breadcrumbs/Breadcrumbs'
import { useDispatch } from 'react-redux'
import { getSuscriberRefID } from '../../../redux/actions/Suscriber'
import InfoIcon from '@mui/icons-material/Info'

export const Suscriptions = () => {
  const classes = useStyle()
  const { id } = useParams()
  const [suscriber, setsuscriber] = useState(null)
  const [rows, setRows] = useState([])
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  const getSuscriptions = async () => {
    try {
      const response = await getSubscriberSuscriptionCommProduct(id)

      if (Array.isArray(response.data)) {
        setRows(orderProducts(response.data))
      }
    } catch (error) {
      console.log(error)
    }
  }
  const orderProducts = (array) => {
    return array.sort((a, b) => {
      if (a.is_active > b.is_active) {
        return -1
      }
      if (a.is_active < b.is_active) {
        return 1
      } else {
        return 0
      }
    })
  }

  const handleGetSuscriber = async () => {
    const param = {
      subscriber_id: id
    }
    const getsuscriber = await dispatch(getSuscriberRefID(param))
    setsuscriber(getsuscriber)
  }

  useEffect(async () => {
    setLoading(true)
    await handleGetSuscriber()
    await getSuscriptions()
    setLoading(false)
  }, [id])

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <BreadcrumbsComponent name={suscriber ? suscriber.subscriber_name : ''} />
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>Suscripciones</Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          La siguiente lista muestra las suscripciones y productos asociados al
          suscriptor {suscriber && suscriber.subscriber_name}.
        </Typography>
      </div>
      <SnackBarSuccess />
      <SnackBarError />
      <div className={classes.boxTable}>
        <ProductsTable
          rows={rows}
          setRows={setRows}
          suscriber={suscriber}
          setLoading={setLoading}
        />
      </div>
    </div>
  )
}
